import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTelegramPlane } from '@fortawesome/free-brands-svg-icons/faTelegramPlane';
import { faVk } from '@fortawesome/free-brands-svg-icons/faVk';

import BaseSemanticLink from '@base/BaseSemanticLink';
import externalLinks from '@config/external-links.json';
import useI18n from '@i18n/index';

const config = {
    epn: [
        {
            id: 'FooterTelegramLink',
            link: externalLinks.tg,
            icon: faTelegramPlane,
            label: 'Telegram link',
        },
        {
            id: 'FooterVkLink',
            link: externalLinks.vk,
            icon: faVk,
            label: 'Vkontakte link',
        },
    ],
    epncpa: [],
}[process.env.NEXT_PUBLIC_PROJECT_NAME];

const SocialIcons: React.FC = () => {
    const { locale } = useI18n();

    return (
        config &&
        locale === 'ru' && (
            <div className="flex text-h1 text-blueGray-600 gap-[16px]">
                {config.map(item => (
                    <BaseSemanticLink
                        key={item.link}
                        id={item.id}
                        to={item.link}
                        aria-label={item.label}
                    >
                        <div>
                            <FontAwesomeIcon icon={item.icon} className="text-blueGray-500" />
                        </div>
                    </BaseSemanticLink>
                ))}
            </div>
        )
    );
};

export default SocialIcons;
